// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/ar/static/NotoKufiArabic-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "arabic-poppins";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  /* Add additional font variations if needed (e.g., bold, italic) */
}
html {
  height: 100% !important;
}

body {
  height: 100% !important;
  overflow: auto;
  padding: 0px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body:lang(ar) {
  font-family: "arabic-poppins", sans-serif;
  /* Apply Arabic font for 'ar' language */
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0px;
  padding: 0px;
}

input,
textarea,
select {
  outline: none;
}

textarea {
  resize: none;
}

/* For Hiding scroll in input type number */
/* Chrome, Safari, Edge, Opera */
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  appearance: textfield;
}

input[type=date] ::-webkit-calendar-picker-indicator {
  cursor: pointer !important;
}

input:disabled {
  background: var(--grey1) !important;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}`, "",{"version":3,"sources":["webpack://./src/index.module.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,+DAAA;EACA,kEAAA;AACF;AAEA;EACE,uBAAA;AAAF;;AAGA;EACE,uBAAA;EACA,cAAA;EACA,YAAA;EACA,sBAAA;EACA,8JAAA;EAGA,mCAAA;EACA,kCAAA;AAFF;;AASA;EACE,yCAAA;EACA,wCAAA;AANF;;AASA;;;;;;;EAOE,WAAA;EACA,YAAA;AANF;;AASA;;;EAGE,aAAA;AANF;;AASA;EACE,YAAA;AANF;;AASA,2CAAA;AACA,gCAAA;AACA;;EAEE,wBAAA;EACA,SAAA;AANF;;AASA,YAAA;AACA;EACE,qBAAA;AANF;;AAQA;EACE,0BAAA;AALF;;AAOA;EACE,mCAAA;AAJF;;AAMA;EACE,+EAAA;AAHF","sourcesContent":["@font-face {\n  font-family: 'arabic-poppins';\n  src: url('./assets/fonts/ar/static/NotoKufiArabic-Regular.ttf') format('truetype');\n  /* Add additional font variations if needed (e.g., bold, italic) */\n}\n\nhtml {\n  height: 100% !important;\n}\n\nbody {\n  height: 100% !important;\n  overflow: auto;\n  padding: 0px;\n  box-sizing: border-box;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  // user-select: none;\n  // -webkit-user-select: none;\n  // -moz-user-select: none;\n  // -ms-user-select: none;\n}\n\nbody:lang(ar) {\n  font-family: 'arabic-poppins', sans-serif;\n  /* Apply Arabic font for 'ar' language */\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np {\n  margin: 0px;\n  padding: 0px;\n}\n\ninput,\ntextarea,\nselect {\n  outline: none;\n}\n\ntextarea {\n  resize: none;\n}\n\n/* For Hiding scroll in input type number */\n/* Chrome, Safari, Edge, Opera */\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"] {\n  appearance: textfield;\n}\ninput[type=\"date\"] ::-webkit-calendar-picker-indicator {\n  cursor: pointer !important;\n}\ninput:disabled {\n  background: var(--grey1) !important;\n}\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
